import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get, useChangeTrackingLens } from '@totalsoft/change-tracking-react';
import { SET_ASSET_HIERARCHY_IMAGE } from '../io/mutations';
import AssetHierarchyTypeComponent from './AssetHierarchyTypeComponent';
import { ASSET_HIERARCHY_IMAGE_SET } from '../io/subscriptions';
import { useToast } from 'hooks/toasts/useToast';
import { useMutation, useSubscription } from 'hooks/apollo';
import { useTranslation } from 'react-i18next';

const AssetHierarchyTypeContainer = ({ data }) => {
  const addToast = useToast();
  const { t } = useTranslation();

  const [hierarchyLens, , resetHierarchy] = useChangeTrackingLens([]);

  const [editing, setEditing] = useState(false);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    resetHierarchy({ ...data });
  }, [data, resetHierarchy]);

  const [saveAssetHierarchyTypeImage] = useMutation(SET_ASSET_HIERARCHY_IMAGE, {
    onError: () => {
      setPending(false);
    }
  });

  useSubscription(ASSET_HIERARCHY_IMAGE_SET, {
    variables: { id: data.id },
    onData: ({ client }) => {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'assetHierarchiesType' });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'assetHierarchies' });
      client.cache.gc();
      addToast(t('AssetHierarchy.List.TypePictureSaved'), 'success');
      setPending(false);
      setEditing(false);
    }
  });

  const handleSave = useCallback(() => {
    setPending(true);
    const item = hierarchyLens |> get;
    const obj = { hierarchyId: item.id, url: item.imageUrl };
    saveAssetHierarchyTypeImage({ variables: { input: obj } });
  }, [hierarchyLens, saveAssetHierarchyTypeImage]);

  const handleEditMode = useCallback(() => {
    setEditing(true);
  }, []);

  const handleCancel = useCallback(() => {
    resetHierarchy(data);
    setEditing(false);
  }, [resetHierarchy, data]);

  return (
    <AssetHierarchyTypeComponent
      hierarchy={hierarchyLens}
      editing={editing}
      pending={pending}
      handleEditMode={handleEditMode}
      handleSave={handleSave}
      handleCancel={handleCancel}
    />
  );
};

AssetHierarchyTypeContainer.propTypes = {
  data: PropTypes.object.isRequired
};

export default AssetHierarchyTypeContainer;
